import StoredLayout from '../../layouts/StoredLayout'
import Installation from './Installation'
export default StoredLayout(Installation)
